<template>
  <v-row>
    <v-col>
      <p class="mb-2">
        <span class="display-1">Site Staff</span>
      </p>
      <StaffTable :staff="staff" :loading="loading"/>
      <br>
      <p v-if="additional_staff" class="mb-2">
        <span class="display-1" v-if="!loading && additional_staff.length > 0">Required Support Staff</span>
      </p>
      <AdditionalStaffTable :staff="additional_staff" :loading="loading"/>
    </v-col>
  </v-row>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/functions'
import StaffTable from './SiteStaff/StaffTable'
import AdditionalStaffTable from './SiteStaff/AdditionalStaffTable'

export default {
  components: {
    StaffTable,
    AdditionalStaffTable
  },
  data() {
    return {
      additional_staff: null,
      staff: null,
      loading: true
    }
  },
  mounted() {
    const vm = this
    const id = vm.$store.state.assignment
    const getOpusApi = firebase.functions().httpsCallable('getOpusApi')

    getOpusApi({
      table: `vendor_assignments/${id}`,
      params: {
        include: 'staff_assignments,event_additional_staff,performance_additional_staff'
      }
    }).then(function(response) {
      // console.log(response.data.result)
      vm.staff = response.data.result.staff_assignments
      if(response.data.result.performance_additional_staff == undefined && response.data.result.event_additional_staff == undefined) {
        vm.additional_staff = null
      }
      else {
        const perf = response.data.result.performance_additional_staff
        vm.additional_staff = perf != undefined && perf.length > 0 ? perf : response.data.result.event_additional_staff
      }
      vm.loading = false
    })
  }
}
</script>